var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoAttention(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 27C48 38.598 38.598 48 27 48C15.402 48 6 38.598 6 27C6 15.402 15.402 6 27 6C38.598 6 48 15.402 48 27ZM24.5 30V15H29.5V30H24.5ZM27 39C28.3807 39 29.5 37.8807 29.5 36.5C29.5 35.1193 28.3807 34 27 34C25.6193 34 24.5 35.1193 24.5 36.5C24.5 37.8807 25.6193 39 27 39Z",
    fill: "#282D37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAttention);
export default __webpack_public_path__ + "static/media/ico_attention.06a8905724a00d4230c389ff811e53cd.svg";
export { ForwardRef as ReactComponent };